import * as React from "react";
const SvgFiRrStarAndCrescent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-star-and-crescent_svg__a)">
      <path
        fill="#062147"
        d="M15.029 20.444C12.113 18.774 9 15.679 9 12s3.113-6.772 6.025-8.442c.732-.42 1.124-1.244.93-2.042C15.62.152 14.14.047 14.14.047 7.615-.467 1.833 3.33.372 9.077c-.902 3.547-.166 7.086 2.073 9.966C4.86 22.148 8.753 24 12.861 24q.69.001 1.343-.052c.868-.073 1.572-.668 1.752-1.48.18-.806-.185-1.6-.928-2.026m-2.168 1.558c-3.496 0-6.799-1.565-8.837-4.187-1.852-2.382-2.46-5.31-1.715-8.246C3.455 5.065 7.846 2 12.962 2q.364 0 .733.021C10.398 4.016 7 7.618 7 12.001c0 4.382 3.393 7.978 6.697 9.98q-.408.02-.836.02m10.842-10.504-1.97 1.606.814 2.484a.833.833 0 0 1-1.245.96l-2.296-1.495-2.256 1.51a.83.83 0 0 1-.963-.025.83.83 0 0 1-.296-.918l.785-2.512-1.982-1.613a.833.833 0 0 1 .539-1.468h2.501l.886-2.483a.833.833 0 0 1 1.562 0l.884 2.484h2.502a.834.834 0 0 1 .537 1.47z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-star-and-crescent_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrStarAndCrescent;
